import { useState } from "react";
import { C, G } from "../../styles/theme";
import PBtn from "../common/PBtn";

export default function NewsletterPopup({ onClose, saveDB }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = () => {
    if (!email.trim()) return;
    saveDB("leads", { id: null, name: "Newsletter Signup", email, phone: "", service: "Newsletter", company: "", message: "Subscribed to newsletter.", status: "new", date: new Date().toISOString().slice(0, 10) });
    setSent(true);
    setTimeout(onClose, 2500);
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(10,20,40,.7)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(5px)" }}>
      <div style={{ background: "#fff", borderRadius: 18, width: "100%", maxWidth: 460, overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,.35)", position: "relative" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 12, right: 12, background: "rgba(0,0,0,.15)", border: "none", width: 27, height: 27, borderRadius: "50%", cursor: "pointer", fontSize: 13, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1 }}>x</button>
        <div style={{ background: G.hero, padding: "28px 28px 22px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>📬</div>
          <h2 style={{ color: "#fff", fontWeight: 800, fontSize: 20, marginBottom: 7 }}>Stay Ahead of the Curve</h2>
          <p style={{ color: "rgba(255,255,255,.72)", fontSize: 13, lineHeight: 1.65 }}>Get the latest on GC lab products, industry insights and exclusive offers straight to your inbox.</p>
        </div>
        <div style={{ padding: "22px 28px 26px" }}>
          {sent ? (
            <div style={{ textAlign: "center", padding: "8px 0" }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>✅</div>
              <div style={{ fontWeight: 700, color: C.blue, fontSize: 15 }}>You are subscribed!</div>
              <div style={{ color: C.gray, fontSize: 13, marginTop: 4 }}>Welcome to the Cyclojet community.</div>
            </div>
          ) : (
            <>
              <div style={{ display: "flex", gap: 7, marginBottom: 12, flexWrap: "wrap" }}>
                {["Lab Updates", "Industry News", "Exclusive Offers"].map(t => (
                  <span key={t} style={{ background: "#f0fdf4", color: "#15803d", fontSize: 11, fontWeight: 600, padding: "3px 9px", borderRadius: 20 }}>{t}</span>
                ))}
              </div>
              <div className="popup-flex">
                <input value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()} placeholder="your@email.com" style={{ flex: 1, padding: "10px 13px", border: `1.5px solid ${C.border}`, borderRadius: 8, fontSize: 14, outline: "none" }} />
                <PBtn onClick={submit}>Subscribe</PBtn>
              </div>
              <div style={{ fontSize: 11, color: C.gray, marginTop: 8, textAlign: "center" }}>No spam. Unsubscribe anytime.</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
